import React, { useRef } from "react"
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
} from "@chakra-ui/react"

import { useReactToPrint } from "react-to-print"
import { Receipt } from "./Receipt"

export const ReceiptModal = ({
  isOpen,
  onClose,
  userProfile,
  setShowSuccessPage,
  nextStep,
  time,
  unit,
  unitLabel,
  unitPurchased,
  amountPaid,
  amountCal,
  utilityType,
}) => {
  const btnStyle = {
    px: "25px",
    _focus: '{{ border: "none" }}',
    size: "sm",
    mx: "10px",
  }

  console.log(userProfile, "userProfilenewnew")
  const handleClose = () => {
    setShowSuccessPage(false)
    onClose()
  }

  const handlePrint = () => {
    setShowSuccessPage(true)
    nextStep()
  }

  const componentRef = useRef()
  const printBadge = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => handlePrint(),
  })

  return (
    <Modal isCentered size="sm" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="gray.500">Payment Receipt</ModalHeader>
        <ModalBody>
          <Receipt
            ref={componentRef}
            userProfile={userProfile}
            amountPaid={amountPaid}
            unitPurchased={unitPurchased}
            unit={unit}
            unitLabel={unitLabel}
            amountCal={amountCal}
            utilityType={utilityType}
          />
        </ModalBody>

        <ModalFooter>
          <Button
            color="#fff"
            fontWeight="bold"
            bg="#77DD77"
            _hover={{ bg: "#77DD77" }}
            {...btnStyle}
            onClick={printBadge}
          >
            Print
          </Button>
          <Button
            color="#fff"
            fontWeight="bold"
            bg="#8B8B8B"
            _hover={{ bg: "#888888" }}
            {...btnStyle}
            onClick={handleClose}
          >
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
